/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { ISearchCategoryViewProps, ISearchFormViewProps, ISearchProductViewProps, ISearchViewProps } from '@msdyn365-commerce-modules/search';
import { INodeProps, Module, Node, UncontrolledTooltip } from '@msdyn365-commerce-modules/utilities';
import MsDyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

const SearchView: React.FC<ISearchViewProps> = props => {
    const {
        Search,
        AutoSuggestAriaLabel,
        AutoSuggestAriaLabelText,
        searchText,
        AutoSuggest,
        ProductSuggest,
        CategorySuggest,
        UlProduct,
        UlCategory,
        form,
        autosuggestCategory,
        autosuggestProduct,
        SearchForm,
        FormWrapper,
        label
    } = props;

    const isSearchFormShow: boolean = SearchForm.className && SearchForm.className.indexOf('bx-show') !== -1 || false;
    if (MsDyn365.isBrowser) {
        // window.document && window.document.body.classList.toggle('menu-open', isSearchFormShow);
        window.document && window.document.body.classList.toggle('search-open', isSearchFormShow);
    }
    return (
        <Module {...Search}>
            {label}
            { /* @ts-ignore */ }
            {_renderForm(form as ISearchFormViewProps, SearchForm, FormWrapper, props)}
            <Node {...AutoSuggest}>
                {searchText && searchText.length > 0 ?
                    <Node {...AutoSuggestAriaLabel}>{AutoSuggestAriaLabelText}</Node> : ''
                }
                {_renderProductSuggestions(ProductSuggest, UlProduct, autosuggestProduct)}
                {_renderCategorySuggestions(CategorySuggest, UlCategory, autosuggestCategory)}
            </Node>
        </Module>
    );
};

const _renderForm = (form: ISearchFormViewProps, SearchForm: INodeProps, FormWrapper: INodeProps, props: ISearchViewProps) => {
    const { cancelBtnAriaLabel, submitBtnAriaLabel } = props.resources;
    return (
        <Node {...SearchForm}>
            <Node {...FormWrapper}>
                {form.input}
                <span id='cancelBtn'>
                {form.cancelBtn}
                </span>
                {<UncontrolledTooltip placement='bottom' trigger={'hover focus'} target={'cancelBtn'}>{cancelBtnAriaLabel}</UncontrolledTooltip>}
                <span id='submitBtn'>
                    {form.submitBtn}
                </span>
                {<UncontrolledTooltip placement='bottom' trigger={'hover focus'} target={'submitBtn'}>{submitBtnAriaLabel}</UncontrolledTooltip>}
            </Node>
        </Node>
    );
};

const _renderProductSuggestions = (
    ProductSuggest: INodeProps,
    UlProduct: INodeProps,
    productSuggestions?: ISearchProductViewProps
) => {
    return (
        productSuggestions && (
            <Node {...ProductSuggest}>
                <Node {...UlProduct}>
                    {productSuggestions.items.map((item, index) => {
                        return (
                            <Node {...item.LiProduct} tabIndex='0' key={item.id || index}>
                                <Node {...item.AProduct} tabIndex='-1'>
                                    {item.text}
                                    {item.price}
                                </Node>
                            </Node>
                        );
                    })}
                </Node>
            </Node>
        )
    );
};

const _renderCategorySuggestions = (
    CategorySuggest: INodeProps,
    UlCategory: INodeProps,
    categorySuggestions?: ISearchCategoryViewProps
) => {
    return (
        categorySuggestions && (
            <Node {...CategorySuggest}>
                <Node {...UlCategory}>
                    {categorySuggestions.title}
                    {categorySuggestions.text.map(text => {
                        return text;
                    })}
                </Node>
            </Node>
        )
    );
};

export default SearchView;